export default "__VITE_ASSET__D5yltQyf__"